import { AFYA_IMARA_QUOTE_FORM_SET_VALUE } from '../../../actions/afyaImara/quote';
import { quoteFormValidation } from './quote';


// medicalHistoryValidation
import { AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE } from '../../../actions/afyaImara/medicalHistory';
import { medicalHistoryValidation } from './medicalHistory';

import { AFYA_IMARA_PERSONAL_DETAILS_FORM_SET_VALUE } from '../../../actions/afyaImara/personalDetails';
import { personalDetailsValidation } from './personalDetails';

import { AFYA_IMARA_CHILD_DETAILS_FORM_SET_VALUE } from '../../../actions/afyaImara/childDetails';
import { childDetailsValidation } from './childDetails';

import { AFYA_IMARA_SPOUSE_DETAILS_FORM_SET_VALUE } from '../../../actions/afyaImara/spouseDetails';
import { spouseDetailsValidation } from './spouseDetails';

import { AFYA_IMARA_NEXT_OF_KIN_FORM_SET_VALUE } from '../../../actions/afyaImara/nextOfKin';
import { nextOfKinValidation } from './nextOfKin';

import { AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE } from '../../../actions/afyaImara/Documents';
import { documentsUploadValidation } from './documents';

import { PAYMENTS_SET_VALUE } from '../../../actions/afyaImara/payments';
import { paymentsFormValidation } from './payments';

import { AFYA_IMARA_AGENT_MODAL_DETAILS_SET_VALUE } from '../../../actions/afyaImara/agentModal';
import { agentModalFormValidation } from './agentModal';

import { SET_SHARE_EMAIL_VALUE } from '../../../actions/ugMotorInsurance/quote';
import { shareQuoteValidation } from './shareQuote';

export const afyaImaraValidation = (store, next, action) => {
    if (action.type.startsWith(AFYA_IMARA_QUOTE_FORM_SET_VALUE)) {
        return quoteFormValidation(store, next, action);
    }
    if (action.type.startsWith(AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE)) {
        return medicalHistoryValidation(store, next, action);
    }
    if (action.type.startsWith(SET_SHARE_EMAIL_VALUE)) {
        return shareQuoteValidation(store, next, action);
    }

    if (action.type.startsWith(AFYA_IMARA_NEXT_OF_KIN_FORM_SET_VALUE)) {
        return nextOfKinValidation(store, next, action);
    }

    if (action.type.startsWith(AFYA_IMARA_PERSONAL_DETAILS_FORM_SET_VALUE)) {
        return personalDetailsValidation(store, next, action);
    }

    if (action.type.startsWith(AFYA_IMARA_CHILD_DETAILS_FORM_SET_VALUE)) {
        return childDetailsValidation(store, next, action);
    }

    if (action.type.startsWith(AFYA_IMARA_SPOUSE_DETAILS_FORM_SET_VALUE)) {
        return spouseDetailsValidation(store, next, action);
    }

    if (action.type.startsWith(AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE)) {
        return documentsUploadValidation(store, next, action);
    }

    if (action.type.startsWith(PAYMENTS_SET_VALUE)) {
        return paymentsFormValidation(store, next, action);
    }

    if (action.type.startsWith(AFYA_IMARA_AGENT_MODAL_DETAILS_SET_VALUE)) {
        return agentModalFormValidation(store, next, action);
    }

    return null;
};
